import { Image } from '@/atoms/Image'
import { usePifOverlay } from '../contexts/PifOverlayContext'

interface ShareDavidCtaProps {
  show: boolean
}

export function ShareDavidCta({ show }: ShareDavidCtaProps) {
  const { openOverlay } = usePifOverlay()

  return (
    <button
      className="fixed bottom-0 right-[6px] z-50 h-[122px] w-[214px] cursor-pointer transition-opacity duration-200 hover:opacity-90"
      style={{
        transform: show ? 'translateX(0)' : 'translateX(100%)',
        transition: 'transform 450ms cubic-bezier(0.68, -0.55, 0.265, 1.55), opacity 200ms ease-in-out',
      }}
      onClick={openOverlay}
      aria-label="Share DAVID with others - Pay it Forward"
    >
      <Image
        alt="Share DAVID with Others"
        className="object-cover"
        src="/v1761152031/theatrical/david/gift-david-graphic-overlay"
        fill
        sizes="214px"
      />
    </button>
  )
}
